/* CFM Gather — Theme JS */
(function () {
  'use strict';

  /* ── Navbar scroll state ── */
  const navbar = document.querySelector('.cfm-navbar');
  if (navbar) {
    const onScroll = () => {
      navbar.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile menu ── */
  /* ── Mobile menu ── */
  const hamburger = document.querySelector('.cfm-navbar__hamburger');
  const mobileMenu = document.querySelector('.cfm-mobile-menu');
  const mobileClose = document.querySelector('.cfm-mobile-menu__close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      hamburger.style.display = 'none';
    });

    const closeMenu = () => {
      mobileMenu.classList.remove('open');
      hamburger.style.display = '';
    };

    if (mobileClose) mobileClose.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  }

  /* ── Hero bg zoom ── */
  const heroBg = document.querySelector('.cfm-hero__bg');
  if (heroBg) setTimeout(() => heroBg.classList.add('loaded'), 100);

  /* ── Scroll reveal ── */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
    }, { threshold: 0.12 });
    revealEls.forEach(el => observer.observe(el));
  }

  /* ── Contact modal ── */
  const backdrop = document.querySelector('.cfm-modal-backdrop');
  const modalForm = document.querySelector('.cfm-modal__form');
  const modalSuccess = document.querySelector('.cfm-modal__success');
  const modalClose = document.querySelector('.cfm-modal__close');

  function openModal() {
    if (backdrop) {
      backdrop.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeModal() {
    if (backdrop) {
      backdrop.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  // Wire all contact triggers
  document.querySelectorAll('[data-contact-trigger]').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); openModal(); });
  });

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', (e) => { if (e.target === backdrop) closeModal(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });

        /* ── Plan a Visit modal ── */
      const visitBackdrop = document.getElementById('cfm-visit-modal');
      const visitModalClose = visitBackdrop
        ? visitBackdrop.querySelector('.cfm-modal__close')
        : null;

      function openVisitModal() {
        if (visitBackdrop) {
          visitBackdrop.classList.add('open');
          document.body.style.overflow = 'hidden';
        }
      }

      function closeVisitModal() {
        if (visitBackdrop) {
          visitBackdrop.classList.remove('open');
          document.body.style.overflow = '';
        }
      }

      document.querySelectorAll('[data-visit-trigger]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          openVisitModal();
        });
      });

      if (visitModalClose) {
        visitModalClose.addEventListener('click', closeVisitModal);
      }

      if (visitBackdrop) {
        visitBackdrop.addEventListener('click', function (e) {
          if (e.target === visitBackdrop) {
            closeVisitModal();
          }
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && visitBackdrop?.classList.contains('open')) {
          closeVisitModal();
        }
      });
            /* ── Event RSVP modal ── */
      const eventBackdrop = document.getElementById('cfm-event-modal');
      const eventModalClose = eventBackdrop
        ? eventBackdrop.querySelector('.cfm-modal__close')
        : null;

      function openEventModal() {
        if (eventBackdrop) {
          eventBackdrop.classList.add('open');
          document.body.style.overflow = 'hidden';
        }
      }

      function closeEventModal() {
        if (eventBackdrop) {
          eventBackdrop.classList.remove('open');
          document.body.style.overflow = '';
        }
      }

      document.querySelectorAll('[data-event-trigger]').forEach(el => {
        el.addEventListener('click', e => {
          e.preventDefault();
          openEventModal();
        });
      });

      if (eventModalClose) {
        eventModalClose.addEventListener('click', closeEventModal);
      }

      if (eventBackdrop) {
        eventBackdrop.addEventListener('click', e => {
          if (e.target === eventBackdrop) closeEventModal();
        });
      }

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && eventBackdrop?.classList.contains('open')) {
          closeEventModal();
        }
      });

  // Form submit
  const contactForm = document.getElementById('cfm-contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const data = new FormData(this);
      const submitBtn = this.querySelector('.cfm-modal__submit');
      submitBtn.textContent = 'Sending…';
      submitBtn.disabled = true;

      // Use Shopify contact form action
      fetch('/contact', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      }).then(() => {
        if (modalForm) modalForm.style.display = 'none';
        if (modalSuccess) modalSuccess.classList.add('visible');
        setTimeout(closeModal, 3000);
      }).catch(() => {
        submitBtn.textContent = 'Try Again';
        submitBtn.disabled = false;
      });
    });
  }

  /* ── Events carousel ── */
  document.querySelectorAll('[id^="eventsTrack-"]').forEach(function(track) {
    const sectionId = track.id; // e.g. eventsTrack-xxxxx
    const prevBtn = document.querySelector('.cfm-events__arrow--prev[data-track="' + sectionId + '"]');
    const nextBtn = document.querySelector('.cfm-events__arrow--next[data-track="' + sectionId + '"]');
    const TILE_W = 276; // 260px tile + 16px gap

    function doAutoScroll() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: TILE_W, behavior: 'smooth' });
      }
    }

    let autoScrollInterval = setInterval(doAutoScroll, 3500);

    track.addEventListener('mouseenter', () => clearInterval(autoScrollInterval));
    track.addEventListener('touchstart', () => clearInterval(autoScrollInterval), { passive: true });
    track.addEventListener('mouseleave', () => {
      clearInterval(autoScrollInterval);
      autoScrollInterval = setInterval(doAutoScroll, 3500);
    });

    if (prevBtn) prevBtn.addEventListener('click', () => {
      clearInterval(autoScrollInterval);
      track.scrollBy({ left: -TILE_W, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      clearInterval(autoScrollInterval);
      track.scrollBy({ left: TILE_W, behavior: 'smooth' });
    });

    // Tile expand/collapse
    track.querySelectorAll('.cfm-event-tile').forEach(function(tile) {
      tile.addEventListener('click', function (e) {
        if (e.target.closest('.cfm-event-tile__detail-close')) {
          this.classList.remove('expanded');
          return;
        }
        if (e.target.closest('.cfm-event-tile__detail-rsvp')) {
          openModal();
          return;
        }
        const wasExpanded = this.classList.contains('expanded');
        track.querySelectorAll('.cfm-event-tile').forEach(function(t) { t.classList.remove('expanded'); });
        if (!wasExpanded) this.classList.add('expanded');
      });
    });
  });

})();
